import type { AxiosRequestConfig } from 'axios';
import axios from '../utils/axios';

export class PatientService {
  /** `config.signal` lets callers abort a stale search. */
  getAllPatients(
    params?: Record<string, any>,
    config?: Pick<AxiosRequestConfig, 'signal'>,
  ) {
    return axios.get('/patients', { ...config, params });
  }
  getPatientByApi(patientId: string) {
    return axios.get(`/patients/${patientId}`);
  }
  exportPatients() {
    return axios.get('/patients/export/csv');
  }
  getPatientName(patientId: string) {
    return axios.get(`/patients/${patientId}/info`);
  }
  createPatient(data: any) {
    return axios.post('/patients', data);
  }
  updatePatient(id: any, data: any) {
    return axios.put(`/patients/${id}`, data);
  }
  deletePatient(id: any, data?: any) {
    return axios.delete(`/patients/${id}`, data);
  }
  /** Patients whose stored mobile can't receive texts (same rule as the SMS sender). */
  getPatientsWithInvalidMobiles() {
    return axios.get<{
      total: number;
      data: {
        id: string;
        firstName: string;
        surName?: string;
        phone: string;
      }[];
    }>('/patients/invalid-mobiles');
  }
  /** `excludeId`: the patient being edited, so a record isn't its own duplicate. */
  checkDuplicateByNameDob(
    firstName: string,
    surName: string | undefined,
    dateOfBirthISO: string,
    excludeId?: string,
  ) {
    const params = new URLSearchParams({
      firstName,
      date_of_birth: dateOfBirthISO,
    });
    if (surName) params.append('surName', surName);
    if (excludeId) params.append('excludeId', excludeId);
    return axios.get(`/patients/check-duplicate?${params.toString()}`);
  }
}
